import { render, staticRenderFns } from "./BlackGradationButton.vue?vue&type=template&id=7d387576&scoped=true&"
import script from "./BlackGradationButton.vue?vue&type=script&lang=js&"
export * from "./BlackGradationButton.vue?vue&type=script&lang=js&"
import style0 from "./BlackGradationButton.vue?vue&type=style&index=0&id=7d387576&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d387576",
  null
  
)

export default component.exports